<crm-single-select
  [options]="options"
  [(selectedItem)]="kind"
  (selectedItemChange)="kindChange.emit($event)"
  [class]="class"
  [styleClass]="styleClass"
  optionValue="name"
  [appendTo]="appendTo"
  [filter]="false"
  [isTemplateCombined]="true">
  <ng-template
    #itemTemplate
    let-type="item">
    {{ type.value | bankStatementRuleConditionKindName }}
  </ng-template>
</crm-single-select>
